// extracted by mini-css-extract-plugin
export default {"comunidade":"styles_comunidade__MvGJm","scene":"styles_scene__GXCMd","piece":"styles_piece__2krTI","float":"styles_float__Z976q","comunidadeFloat":"styles_comunidadeFloat__yzbO9"};